import { createClient } from '@supabase/supabase-js';
import { retryingFetch } from './lib/networkRetry';
import { t } from './i18n';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  // A read the network dropped is tried again, and what still gets no answer
  // says so in Spanish instead of "TypeError: Failed to fetch" (15 Sep 2026).
  // Writes are never repeated. See lib/networkRetry.js.
  global: {
    fetch: retryingFetch((input, init) => fetch(input, init), {
      offline: { name: t('common.offlineName'), message: t('common.offline') },
    }),
  },
});

// Helper function for error handling
export const handleSupabaseError = (error) => {
  if (error) {
    console.error('Supabase error:', error);
    return error.message || 'An unexpected error occurred.';
  }
  return null;
};